import {useTranslation} from "react-i18next";
import {Modal} from "../../../components/User_Side/modal/Modal";
import {WHATSAPP_NUMBER} from "../../../constants/constants";
import ankletByThePool from "../../../assets/images/specials/anklet_by_the_pool.jpeg";
import ankletByThePool2 from "../../../assets/images/specials/anklet_by_the_pool2.jpeg";


const Specials = ({ props }: {
    props: {
        modal: boolean;
        setModal: (modal: boolean) => void;
        submitted: boolean;
        setSubmitted: (submitted: boolean) => void;}
}) => {
    const {t} = useTranslation()

    return (
        <div className={"Specials"}>
            <div className={"textes-wrapper"}>
                <div className={"section"}>
                    <div className={"section-paragraph"}>
                        <div className={"photo-and-text"}>
                            <div>
                                <h3 className={"section-title"}>{t("specials.title")}</h3>
                                <button className="btn newsletter-button" onClick={() => props.setModal(true)}>
                                    {t('specials.form.title')}
                                </button>
                                <br/><br/>
                                <p><b>{t("specials.subtitle_anklets")}</b></p>
                                <p>{t("specials.texts.anklets")}</p>
                                <p>{t("specials.texts.exclusivity")}</p>
                            </div>
                            <div className={"vertical-photo-collection"}>
                                <img alt={"anklet by the pool 2"} src={ankletByThePool2} height={200}/>
                                <img alt={"anklet by the pool"} src={ankletByThePool} height={200}/>
                            </div>
                        </div>
                    </div>
                </div>
                {props.modal && (
                    <Modal
                        message={t("specials.form.title")}
                        fields={[
                            { name: 'firstName', label: `${t("specials.form.firstName")}`},
                            { name: 'phone', label: `${t("specials.form.phone")}`},
                            { name: 'textarea', label: `${t("specials.form.textarea")}`, type: 'textarea' },
                        ]}
                        confirmLabel={t("testimony.send")}
                        cancelLabel={t("testimony.cancel")}
                        onCancel={() => props.setModal(false)}
                        submitted={props.submitted}
                        confirmationText={t("specials.form.confirmation")}
                        onConfirm={async (data) => {
                            if (!data?.firstName || !data?.phone || !data?.textarea) return;
                            try {
                                const fd = new FormData();
                                fd.append('firstName', data.firstName);
                                fd.append('phone', data.phone);
                                fd.append('textarea', data.textarea);
                                //await createSpecialDemand(fd);
                                props.setSubmitted(true);

                                const message = `Bonjour Mariposa,\nDemande de création spéciale de la part de ${data.firstName} (${data.phone}) :\n ${data.text_area}}`;
                                const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
                                window.open(waUrl, '_blank');
                                setTimeout(() => props.setSubmitted(false), 1000);
                                setTimeout(() => props.setModal(false), 1000);

                            } catch (e) { console.error(e); }
                        }}
                    />
                )}
            </div>
        </div>
    )
}
export default Specials;
